import { SessionListItem } from "./course/session-list-item.model";

export class MediaFile {
  constructor(
    public id:string,
    public name:string = "",
    public path: string,
    public createdAt: Date,
    public type:'attest'|'file' = "file",
    public session?:SessionListItem,
    public branch?:{
      id:string,
      name:string,
      logo:string
    },
    public series?:{
      id:string,
      name:string,
      courseName:string,
    },
    public fileType?:{id:string, translation:string}|null,
  ){}
}
